import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IntelligenceDiagram } from './IntelligenceDiagram';
import { easeOutStrong } from '../../utils/motion';
export function HomeHero() {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-28" data-id="element-1157" data-mp="2470qg9yj0rdv">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center" data-id="element-1158" data-mp="295c12mwnb5x5">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="lg:col-span-7" data-id="element-1159" data-mp="2wuwtrxilphjm">
          <h1 className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-ink-dark leading-[1.03] tracking-tight" data-id="element-1160" data-mp="2n2hej7yov72f">
            Building a more intelligent future.
          </h1>
          <p className="mt-8 text-xl lg:text-2xl text-ink-dark/80 leading-relaxed max-w-2xl" data-id="element-1161" data-mp="3fqwj10k726zi">
            SyNeural connects knowledge, develops human capability and helps institutions turn insight into action.
          </p>
          <p className="mt-5 text-lg text-ink-muted leading-relaxed max-w-2xl" data-id="element-1162" data-mp="jwe75z9kq954">
            Through our Semantic Knowledge Platform, Human Capability Framework, Noetivra Core and connected workspaces,
            we are laying the foundations for a more capable world.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6" data-id="element-1163" data-mp="suzltjbxd40m">
            <a href="/solutions" className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 shadow-sm whitespace-nowrap" data-id="element-1164" data-mp="17ntek6g7jgn8">
              Find your solution
              <ArrowRight size={18} aria-hidden="true" data-id="element-1165" data-mp="1cip6l6lg240c" />
            </a>
            <a href="/how-it-works" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1166" data-mp="3iejj6wghyyqt">
              See how it works
              <ArrowRight size={16} aria-hidden="true" data-id="element-1167" data-mp="1man894d2eb6v" />
            </a>
          </div>
          <p className="mt-8 text-sm text-ink-muted" data-id="element-1168" data-mp="1mcgeiijrmtec">Interactive demos available. Production platform under development.</p>
        </motion.div>

        <div className="lg:col-span-5" data-id="element-1169" data-mp="1w92vuxcvv2bm">
          <IntelligenceDiagram data-id="element-1170" data-mp="1w6q7a1cmdtpl" />
        </div>
      </div>
    </section>;
}